import { Button } from "@mui/material";
import styled from "styled-components";

export const BtnExport = styled(Button)`
margin-top: 1rem;
align-self: flex-end;
`